import {OpenFeature} from "@openfeature/react-sdk";
import {OFREPWebProvider} from "@openfeature/ofrep-web-provider";

export const buildGlobalApiBaseUrl = () => {
  const env = process.env.ENVIRONMENT_NAME;

  let baseUrl =
    env === "production" ?
      "https://api.global.breachrx.io" :
      env === "development" ?
        "https://api.global.development.breachrx.io" :
        env === "localdev" && process.env.STAGE ?
          `https://api.global.${process.env.STAGE}.breachrx.dev` :
          "";

  if (!baseUrl) {
    console.warn(
      "Could not determine the global api url, if this is a local development " +
      "environment please ensure SST_STAGE is set",
    );

    baseUrl = "https://api.global.unknown.breachrx.dev";
  }

  return baseUrl;
};

const withProviderDefaults = (fetchImplementation, {apiKey, namespace}) => {
  const baseFetch = fetchImplementation ?? globalThis.fetch?.bind(globalThis);

  if (!baseFetch) {
    throw new Error("A fetch implementation is required when globalThis.fetch is unavailable");
  }

  return async (input, init) => {
    const request = new Request(input, init);

    if (!request.headers.has("Authorization") && apiKey) {
      request.headers.set("Authorization", `Bearer ${apiKey}`);
    }

    if (request.method !== "POST") {
      return baseFetch(request);
    }

    const body = await request.clone().json();
    const context = {
      ...body.context,
      namespace,
    };

    return baseFetch(
      new Request(request, {
        body: JSON.stringify({...body, context}),
      }),
    );
  };
};

export const configureProvider = (configuration, {defaultTimeoutMs} = {}) => {
  const {namespace, apiKey, ...options} = configuration;

  const baseUrl = `${buildGlobalApiBaseUrl()}/feature-flags`;

  console.info("Feature flags configured with url:", baseUrl);

  return {
    options: {
      ...options,
      timeoutMs: options.timeoutMs ?? defaultTimeoutMs,
      baseUrl,
      fetchImplementation: withProviderDefaults(options.fetchImplementation, {apiKey, namespace}),
    },
    namespace,
  };
};

export class BreachRxWebProvider extends OFREPWebProvider {
  constructor(configuration) {
    const {options, namespace} = configureProvider(configuration, {
      defaultTimeoutMs: 10_000,
    });

    super(options);

    this.metadata = {
      name: "BreachRx Web Provider",
    };
    this.namespace = namespace;
  }
}

export const initializeFeatureFlags = () => {
  const orgName = window.location.hostname.split(".").shift();

  OpenFeature.setProvider(
    new BreachRxWebProvider({
      namespace: "incident-response",
      orgName,
      apiKey: process.env.FEATURE_FLAG_INCIDENT_RESPONSE_PUBLIC_API_KEY,
      pollInterval: 900_000, // 15 minutes
    }),
    {orgName},
  );
};
